import React from 'react'
import {
  SectionWrapper,
  PaddedDiv,
} from 'modules/Exp-Candidates/Components/Styles/style'
import DrivePage from 'modules/Exp-Candidates/Components/DrivePage/index'

const ExpCandidates = ({
  listOfDrivesDetails,
  getDriveListData,
  requestToChange,
  confirmDrive,
  recreateCall,
  setDashboardNavs,
  dashboardNavs,
}) => {
  return (
    <SectionWrapper column>
      <PaddedDiv column>
        <DrivePage
          listOfDrivesDetails={listOfDrivesDetails || []}
          getDriveListData={getDriveListData}
          requestToChange={requestToChange}
          confirmDrive={confirmDrive}
          setDashboardNavs={setDashboardNavs}
          dashboardNavs={dashboardNavs}
          recreateCall={recreateCall}
        />
      </PaddedDiv>
    </SectionWrapper>
  )
}

export default ExpCandidates
